import Vue from 'vue';
if(document.getElementById('course-payment')){
    new Vue({
        el: '#course-payment',
        data: {
            load: true,
            payment: {
                payment_1: false,
                payment_2: false,
                payment_3: false
            }
        },
        computed: {
            coursePayment() {
                return (this.payment.payment_1 && this.payment.payment_2 && this.payment.payment_3);
            }
        }
    });
}
